/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const ACC_ERR_MSG = 'ACC_ERR_MSG';
export const ACC_PLAN_LIST = 'ACC_PLAN_LIST';
export const ACC_REBARE_LIST = 'ACC_REBARE_LIST';
export const ACC_PLAN_TYPE = 'ACC_PLAN_TYPE';
export const ACC_REBATE_PGM = 'ACC_REBATE_PGM';
export const ACC_URA_TO_USE = 'ACC_URA_TO_USE';
export const ACC_DISPLAY_BY = 'ACC_DISPLAY_BY';
export const ACC_QTR_OPT = 'ACC_QTR_OPT';
export const ACC_FROM_QTR = 'ACC_FROM_QTR';
export const ACC_TO_QTR = 'ACC_TO_QTR';
export const ACC_FLD_ERR = 'ACC_FLD_ERR';
export const ACC_ALL_REBATE = 'ACC_ALL_REBATE';
export const ACC_MANU_SELECT = 'ACC_MANU_SELECT';
export const ACC_MANU_LIST = 'ACC_MANU_LIST';
export const ACC_END_QTR = 'ACC_END_QTR';
export const ACC_START_QTR = 'ACC_START_QTR';
export const ACC_RESET_STORE = 'ACC_RESET_STORE';
export const AR_SMRY_FOR_MFG = 'AR_SMRY_FOR_MFG';
export const AR_SMRY_FOR_QTR = 'AR_SMRY_FOR_QTR';
export const REBATE_LIST_BY_PLAN = 'REBATE_LIST_BY_PLAN';
export const MFG_AR_ALL_RPC = 'MFG_AR_ALL_RPC';
export const FIRST_LOAD = 'FIRST_LOAD';
export const CLEAR_REQ_ACC_REC_SEARCH_PAGE = 'CLEAR_REQ_ACC_REC_SEARCH_PAGE';
